<mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="pinnedPanels[silentDataKey]"
    #purchaserExpansionPanel
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">people</mat-icon>
            <b>Purchaser</b>
        </mat-panel-title>
        <mat-panel-description class="end-center flex-row">
            @if (purchaserExpansionPanel.expanded || silentData[silentDataKey]) {
                <button mat-icon-button (click)="togglePanelPinned($event, silentDataKey)">
                    <mat-icon svgIcon="pin" [ngClass]="{ 'cb-accent': silentData[silentDataKey] }">
                    </mat-icon>
                </button>
            }
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        @if (clientAccountLegalNameField.isVisible) {
            <cb-display-value-new
                class="flex-50"
                label="Account"
                [showBtn]="!!lotMappedItem?.clientSale?.saleNumber"
                [btnHref]="clientRoute"
                value="{{lotMappedItem?.clientAccount?.legalName | cbDasher}}"
            >
            </cb-display-value-new>
        }
        <div class="flex-wrap flex">
            @if (contactsAssignedToAccountField.isVisible) {
                @for (clientAccount of lotMappedItem.clientAccountContactIds; track clientAccount) {
                    <cb-display-value-new class="flex-50" label="Contact Assigned">
                        {{ clientAccount?.label | cbDasher }}
                    </cb-display-value-new>
                }
            }
            @if (contractTypeField.isVisible) {
                <cb-display-value-new class="flex-50" label="Contract Type">
                    {{
                        lotMappedItem?.contractType
                            | cbEnumToLabel: LOT_CONTRACT_TYPE_ENUM
                            | cbDasher
                    }}
                </cb-display-value-new>
            }
            @if (contractStatusField.isVisible) {
                <cb-display-value-new class="flex-50" label="Contract Status">
                    {{lotMappedItem?.contractType | cbEnumToLabel:LOT_CONTRACT_TYPE_ENUM | cbDasher}}
                </cb-display-value-new>
            }
            @if (jobNumberField.isVisible) {
                <cb-display-value-new
                    class="flex-50"
                    label="Client Sale Number"
                    [showBtn]="!!lotMappedItem?.clientSale?.saleNumber"
                    [btnHref]="clientSaleRoute"
                    value="{{lotMappedItem?.clientSale?.saleNumber | cbDasher}}"
                >
                </cb-display-value-new>
            }
            @if (vendorNameThirdPartyField.isVisible) {
                <cb-display-value-new class="flex-50" label="Vendor">
                    {{ lotMappedItem?.thirdPartyLotVendor | cbDasher }}
                </cb-display-value-new>
            }
        </div>
    </div>
</mat-expansion-panel>
